module.exports = __webpack_public_path__ + "static/img-lady-bbad185d4844b7c731883902c177f7d3.png";